import React, { useState } from "react";
import "../css/Login.css";
import { Button, Grid2, Link, Paper, TextField, Snackbar, Alert } from "@mui/material";
import { useAuth } from "../hooks/AuthProvider";
import { useNavigate } from "react-router-dom";
import Wait from "../components/Wait";

export default function Login() {
    const [procesando, setProcesando] = useState(false)
    const [mensaje, setMensaje] = useState("")
    const [empresa, setEmpresa] = useState("")
    const [usuario, setUsuario] = useState("")
    const [clave, setClave] = useState("")

    const {handleLogin} = useAuth()
    const navigate = useNavigate()

    const puedeLoguear = () => {
        let resultado = true;

        if (empresa.length == 0) {
            setMensaje("Debe digitar el usuario de su empresa")
            return false;
        }
        if (usuario.length == 0) {
            setMensaje("Debe digitar su usuario")
            return false;
        }
        if (clave.length == 0) {
            setMensaje("Debe digitar su clave")
            return false;
        }

        return resultado;
    }

    const handleLoguear = () => {
        if (puedeLoguear()) {
            loguear();
        }
    }

    const loguear = async () => {
        setProcesando(true)
        let resultado = await handleLogin(empresa, usuario, clave)
        console.log(resultado)
        setProcesando(false)
        if (resultado.respuesta=="S"){
            navigate("/dashboard")
        } else {
            setMensaje(resultado.mensaje)
        }
    }

    return (
        <div className="Log-cuerpo">
            <div className="Log-marco">
                <Wait procesando={procesando}/>
                <Snackbar
                    open={mensaje.length == 0 ? false : true}
                    autoHideDuration={6000}
                    anchorOrigin={{ vertical: "top", horizontal: "center" }}
                    onClose={()=>{setMensaje("")}}
                >
                    <Alert severity="error" onClose={()=>{setMensaje("")}} variant="filled">{mensaje}</Alert>
                </Snackbar>
                <Paper elevation={2} className="Log-marco-paper">
                    <div className="Log-lado-a">
                        <img
                            width={"100px"}
                            height={"auto"}
                            src={"./logo.png"}
                        />
                    </div>
                    <div className="Log-lado-b">
                        <div className="Log-titulo">
                            Inicio Sesión
                        </div>
                        <Grid2 container spacing={3}>
                            <Grid2 size={12}>
                                <TextField
                                    color="coopinfa"
                                    value={empresa}
                                    type="text"
                                    fullWidth
                                    InputLabelProps={{ shrink: true }}
                                    label="Empresa"
                                    onChange={(event) => { setEmpresa(event.target.value) }}
                                />
                            </Grid2>
                            <Grid2 size={12}>
                                <TextField
                                    color="coopinfa"
                                    value={usuario}
                                    type="text"
                                    fullWidth
                                    InputLabelProps={{ shrink: true }}
                                    label="Usuario"
                                    onChange={(event) => { setUsuario(event.target.value) }}
                                />
                            </Grid2>
                            <Grid2 size={12}>
                                <TextField
                                    color="coopinfa"
                                    value={clave}
                                    type="password"
                                    fullWidth
                                    InputLabelProps={{ shrink: true }}
                                    label="Clave"
                                    onChange={(event) => { setClave(event.target.value) }}
                                />
                            </Grid2>
                        </Grid2>
                        <div className="Log-boton">
                            <Button variant="contained" color="coopinfa" sx={{ width: "200px" }} onClick={handleLoguear}>
                                Entrar
                            </Button>
                        </div>
                        <div className="Log-olvido">
                            <Link>Olvidé mi contraseña</Link>
                        </div>
                    </div>
                </Paper>
            </div>
        </div>
    )
}